<script>
  import { navigate } from 'svelte-routing';
  import { client } from 'root/api/index.js';
  import NavLink from '../../components/NavLink.svelte';
  import * as yup from 'yup';
  import InfoAlert from '../../components/Alert/InfoAlert.svelte';
  import Loader from '../../components/Loader.svelte';
  import { createForm } from 'svelte-forms-lib';
  import { configItem } from '../../components/Helper';
  import FormInput from '../../components/FormControls/FormInput.svelte';
  import { onMount } from 'svelte';
  export let code;

  let isValid = true;

  let isFormPending = false;
  let serverErrors = [];
  const { form, errors, handleChange, handleSubmit } = createForm({
    initialValues: {
      code: code,
      password: '',
      confirmPassword: '',
    },
    validationSchema: yup.object().shape({
      password: yup
        .string()
        .required()
        .test('passwordValidate', configItem.passwordValidation.message, function (value) {
          if (value.length == 0) {
            return true;
          }
          if (value != undefined && value != '') {
            const matchVal = value.match(configItem.passwordValidation.expression);
            return matchVal == null ? false : true;
          }
        }),
      confirmPassword: yup
        .string()
        .label('Confirm Password')
        .oneOf([yup.ref('password'), null], 'Passwords must match')
        .required(),
    }),
    onSubmit: (values) => {
      isFormPending = true;
      client
        .setupPassword(values)
        .then((response) => {
          navigate('/success', { replace: true });
        })
        .catch((err) => {
          isFormPending = false;
          serverErrors = [err.message];
        });
    },
  });

  onMount(() => {
    client
      .validateSetupCode({ code })
      .then((response) => {
        isValid = true;
      })
      .catch((err) => {
        isValid = false;
      });
  });
</script>

<div class="d-flex w-100 h-100 justify-content-center align-items-center login-bg">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="card-body position-relative">
            <div
              class="logo-block rounded-circle d-flex flex-column align-items-center justify-content-center mt-2 mb-3"
            >
              <img
                alt=""
                src="/images/logo.png"
              />
              <h5 class="color-blue mb-0 mt-3">Create Password</h5>
              {#if isValid}
                <span class="color-blue mb-3 d-block font-weight-200 text-center text-muted mt-2">
                  Create your password and confirm
                </span>
              {/if}
            </div>

            <div
              class="w-100 h-100 d-flex flex-column align-items-center
									justify-content-center login-container"
            >
              {#if isValid}
                <InfoAlert
                  message={serverErrors}
                  class="alert alert-danger w-100 mb-3"
                />
                <div class="w-100">
                  <FormInput
                    label="Password "
                    type="password"
                    placeholder="Enter Password"
                    handleChange={handleChange}
                    name="password"
                    error={$errors.password}
                    bind:value={$form.password}
                  />
                  <label
                    alt=""
                    for=""
                    class="password-notes"
                    >{configItem.passwordValidation.note}
                  </label>
                </div>

                <div class="w-100">
                  <FormInput
                    label="Confirm Password "
                    type="password"
                    placeholder="Enter Confirm Password"
                    handleChange={handleChange}
                    name="confirmPassword"
                    error={$errors.confirmPassword}
                    bind:value={$form.confirmPassword}
                  />
                  <label
                    alt=""
                    for=""
                    class="password-notes">{configItem.passwordValidation.note}</label
                  >
                </div>
                <div class="form-group mb-3 w-100">
                  <button
                    type="submit"
                    class="btn btn-primary shadow-none background-blue mb-0 text-white add-task ripple w-100"
                    on:click={handleSubmit}
                    disabled={isFormPending}
                  >
                    {#if isFormPending}
                      <Loader />
                    {:else}Submit{/if}
                  </button>
                </div>
              {:else}
                <InfoAlert
                  message="This link has been expired. Request another one to reset your password"
                  class="alert alert-danger w-100 mb-3"
                />
              {/if}
            </div>
            <!-- <div class="form-group mb-0 text-center">
												<NavLink to="/login" Style="btn font-size-12 shadow-none forgot-password-links bg-transparent border-0 text-muted">
														<span>Login</span>
												</NavLink>
											</div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<style lang="scss">
  .card {
    margin-bottom: 24px;
    -webkit-box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
    box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
  }
  .card {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border: 1px solid #cdd9e9;
    border-radius: 0.25rem;
    border: 1px solid #cdd9e9;
  }
  .logo-block {
    img {
      max-width: 200px;
    }
  }
</style>
